import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {TippingHistoryRecordHeaderBox} from "./boxes/tipping-history-record-header.box";
import {TippingHistoryRecordGameNameBox} from "./boxes/game-name/tipping-history-record-game-name.box";
import React from "react";
import {CyClass} from "../../../../../common/cy-classes";
import {observer} from "mobx-react";
import {TippingHistoryTipIdContainerBox} from "./boxes/ids-container.box/tipping-history-ids-container.box";
import {TippingHistoryRecordGameTipIdBox} from "./boxes/game-tip-id/tipping-history-record-tip-id.box";
import {ITippingHistoryRecordViewModel} from "../../../../services/tipping-history/models/tipping-history-view-model.interface";

interface TippingHistoryRecordHeaderComponentProps {
    record: ITippingHistoryRecordViewModel;
}

export const TippingHistoryRecordHeaderComponent = observer(
    class TippingHistoryRecordHeaderComponent extends OrbitComponent<TippingHistoryRecordHeaderComponentProps> {
        render() {
            return (
                <TippingHistoryRecordHeaderBox>
                    <TippingHistoryRecordGameNameBox className={CyClass('cy-tipping-history-game-name')}>
                        {this.props.record.gameName}
                    </TippingHistoryRecordGameNameBox>
                    <TippingHistoryTipIdContainerBox>
                        <TippingHistoryRecordGameTipIdBox className={CyClass('cy-tipping-history-tip-id')}>{this.props.record.tipId}</TippingHistoryRecordGameTipIdBox>
                    </TippingHistoryTipIdContainerBox>
                </TippingHistoryRecordHeaderBox>
            );
        }
    }
);